const shortTicketPrintMessage = (message, fallback) => {
  if (
    String(message || "")
      .toLowerCase()
      .includes("ticket regeneration")
  ) {
    return "Ticket regeneration in progress. Printing is disabled.";
  }

  return message || fallback;
};

export const parseTicketPrintErrorPayload = (
  payload,
  fallback = "Failed to print ticket",
) => {
  if (payload?.errorMessage || payload?.message) {
    return shortTicketPrintMessage(payload.errorMessage || payload.message, fallback);
  }

  if (payload instanceof ArrayBuffer) {
    try {
      const json = JSON.parse(new TextDecoder().decode(payload));
      return shortTicketPrintMessage(
        json.errorMessage || json.message || json.data?.errorMessage || json.data?.message,
        fallback,
      );
    } catch {
      return fallback;
    }
  }

  return fallback;
};

export const getTicketPrintErrorMessage = (
  error,
  fallback = "Failed to print ticket",
) => {
  const responseMessage = parseTicketPrintErrorPayload(error?.response?.data, "");
  if (responseMessage) return responseMessage;

  return shortTicketPrintMessage(
    error?.errorMessage || error?.message,
    fallback,
  );
};

export const isTicketRegenerationBlocked = (payload) =>
  Boolean(payload?.jobId || payload?.progress) &&
  String(payload?.message || payload?.errorMessage || "")
    .toLowerCase()
    .includes("ticket regeneration");
